/** Expenses infra API — repos, remotes, SQL helpers, attachments, file picker. */
export {
  isExpensesModuleEnabled,
  ensureLocalExpenseCategories,
  listExpenseCategories,
  listExpensesForBranch,
  countExpensesForBranch,
  summarizeExpensesForBranch,
  listExpensesForExport,
  getExpenseById,
  getExpenseByPurchaseOrderId,
  listExpensesByPurchaseOrderId,
  listLinkedPurchaseExpensesForBranch,
  listSettlementsForExpense,
  createExpense,
  settleExpense,
  voidSettlement,
  createExpenseWithCashSettlement,
  voidExpense,
  sumExpensesForBranchPeriod,
  fetchRemoteExpensesSummary,
  fetchRemoteProfitLossSummary,
} from './infra/expensesRepo';

export {
  listBranchSettlementsRemote,
} from './infra/expensesSettlementsRemote';

export {
  listBranchSettlementsLocal,
  listBranchSettlementsExportLocalQuery,
  summarizeBranchSettlementsLocalQuery,
} from './infra/expensesRepoSettlementsLocal';

export {
  defaultExpensePeriodFrom,
  todayIsoDate,
  resolvePeriodDates,
} from './infra/expenseListSql';

export {
  saveExpenseAttachmentLocal,
  listAttachmentsForExpense,
  upsertPulledExpenseAttachmentLocal,
  deleteExpenseAttachmentLocal,
  markLocalExpenseAttachmentSynced,
} from './infra/expenseAttachmentsRepo';

export {
  pickAttachmentFile,
  type PickedAttachmentFile,
} from '../shared/attachments/infra/pickAttachmentFile';

export {
  mapExpenseCommandError,
  rawExpenseErrorText,
  expenseCommandErrorFromRaw,
  type MappedExpenseCommandError,
} from './infra/mapExpenseCommandError';
